import * as types from '../mutation-types';
import router from '../../router';
import bus from '../../services/bus-event.js';
import globalStore from '../index';
import { clearAllNotifications } from '../../cordova/index.js';
import { normalizePushNotification } from '@/config/notificationSound';

const state = {
    deviceReady: false,
    deviceOnline: false,
    device: null,
    version: null,
    deviceId: null,
    foreground: null,
    pushNotificationProvider: 'default'
};

const getters = {
    device: state => state.device,
    version: state => state.version ? parseInt(state.version.replace(/\./g, ''), 10) : 0,
    networkState: state => state.deviceOnline,
    deviceReady: state => state.deviceReady,
    deviceId: state => state.deviceId,
    pushNotificationProvider: state => state.pushNotificationProvider,
    deviceData: state => {
        let data = {};
        if (state.device) {
            // https://capacitorjs.com/docs/apis/device#deviceinfo
            data.device_type = state.device.platform + ' ' + (state.device.androidSDKVersion || state.device.iOSVersion);
        }
        if (state.deviceId) {
            data.device_id = state.deviceId;
        }
        if (state.pushNotificationProvider) {
            data.provider = state.pushNotificationProvider;
        }
        if (state.version) {
            data.app_version = parseInt(state.version.replace(/\./g, ''), 10);
        } else {
            data.app_version = 0;
        }
        return data;
    },
    platform: state => {
        let platform = 'browser';
        if (state.device && state.device.platform) {
            platform = state.device.platform.toLowerCase();
        }
        return platform;
    },
    foreground: state => state.foreground
};

const actions = {
    notificationArrive (context, notification) {
        normalizePushNotification(notification);
        console.log('cordova/notificationArrive called with:', notification);
        console.log('Notification URL:', notification.url);
        console.log('User is driver:', globalStore.getters['auth/isChofer']);

        switch (notification.url) {
            case 'aceptar':
            case 'cancelar':
            case 'llegando':
            case 'ofrecidos':
            case 'nuevo-mensaje':
            case 'nuevo-audio':
            case 'reserva-pagada':
            case 'reserva-proxima':
            case 'chofer-finaliza':
                if (globalStore.getters['auth/isChofer']) {
                    console.log('Dispatching to driver/handlerNotification');
                    globalStore.dispatch('driver/handlerNotification', notification);
                } else {
                    console.log('Dispatching to passenger/handlerNotification');
                    globalStore.dispatch('passenger/handlerNotification', notification);
                }
                break;
            case 'tarifa-actualizada':
                if (!globalStore.getters['auth/isChofer']) {
                    console.log('Dispatching to passenger/handlerNotification (tarifa)');
                    globalStore.dispatch('passenger/handlerNotification', notification);
                }
                break;
            default:
                console.log('Unknown notification URL:', notification.url);
                break;
        }
    },

    deviceOnline (store) {
        store.commit(types.CORDOVA_ONLINE);
    },

    deviceOffline (store) {
        store.commit(types.CORDOVA_OFFLINE);
    },

    onPausa (store) {
        store.commit('CORDOVA_SET_BACKGROUND');
        console.log('background');
    },

    onResume (store) {
        store.commit('CORDOVA_SET_FOREGROUND');
        console.log('foreground', globalStore.getters['geolocation/locationEnabled'], globalStore.getters['geolocation/permissionSet']);
        bus.emit('cordova_resume');
        if (!globalStore.getters['geolocation/locationEnabled'] && globalStore.getters['geolocation/permissionSet']) {
            // no tengo geo, capaz que estoy volviendo de la pantalla de permisos
            console.log('starting geo again');
            globalStore.commit('geolocation/PERMISION_SET', true);
            // globalStore.dispatch('geolocation/start');
            window.location.reload();
        }
        clearAllNotifications();
    },

    onBackButton (store) {
        let result = bus.emit('backbutton');
        console.log('onBackButton', result, router.currentRoute.name);
        if (!result) {
            if (router.stack.length > 0 && router.currentRoute.name !== 'login') {
                // console.log('stack', JSON.stringify(router.stack[0]));
                router.go(-1);
            } else {
                navigator.Backbutton.goHome();
            }
        }
    }
};

const mutations = {
    [types.CORDOVA_DEVICEREADY] (state) {
        state.deviceReady = true;
        state.foreground = true;
    },
    [types.CORDOVA_ONLINE] (state) {
        state.deviceOnline = true;
    },
    [types.CORDOVA_OFFLINE] (state) {
        state.deviceOnline = false;
    },
    [types.CORDOVA_SET_DEVICE] (state, device) {
        state.device = device;
    },
    [types.CORDOVA_SET_VERSION] (state, version) {
        state.version = version;
    },
    [types.CORDOVA_DEVICE_REGISTER] (state, id) {
        state.deviceId = id;
    },
    'CORDOVA_SET_BACKGROUND' (state) {
        state.foreground = false;
    },
    'CORDOVA_SET_FOREGROUND' (state) {
        state.foreground = true;
    },
    [types.CORDOVA_DEVICE_UPDATED] (state, id) {
        state.deviceId = id;
    },
    'CORDOVA_PN_PROVIDER' (state, provider) {
        state.pushNotificationProvider = provider;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cordova.js